import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Providers } from './providers';
import { router } from './router';
import { useAuthStore } from '@stores/auth.store';

/** Root component: initialise the session, then render the router. */
export function App(): React.JSX.Element {
  const initialize = useAuthStore((s) => s.initialize);

  useEffect(() => {
    void initialize();
  }, [initialize]);

  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
